// Module
export * from './lib/shared-interfaces.ng-module';

// Interfaces
export * from './lib/interface/ibasic';
export * from './lib/interface/icadastro';
export * from './lib/interface/icliente';
export * from './lib/interface/iconta';
export * from './lib/interface/icustomer';
export * from './lib/interface/idado';
export * from './lib/interface/idepartamento';
export * from './lib/interface/iform';
export * from './lib/interface/iget-form-by-name';
export * from './lib/interface/iget-form';
export * from './lib/interface/ilogin-with-user';
export * from './lib/interface/iget-label-value-combobox-by-form';
export * from './lib/interface/iget-subprocess-by-user';
export * from './lib/interface/iget-getrelationships-by-post';
export * from './lib/interface/ilist-item';
export * from './lib/interface/ipapel';
export * from './lib/interface/iqueue-item';
export * from './lib/interface/iservice-provider';
export * from './lib/interface/ityped-value';
export * from './lib/interface/iuser-exist';
export * from './lib/interface/iusuario';
export * from './lib/interface/iatividade-componente-dal';
export * from './lib/interface/ikey-value';
export * from './lib/interface/iconfig-modules';
export * from './lib/interface/iocorrencia';
export * from './lib/interface/idialog-data';
export * from './lib/interface/ipatient';
export * from './lib/interface/ivital-sign';
export * from './lib/interface/imovimentacao-de-leito';
export * from './lib/interface/ievolucao-enfermagem';
export * from './lib/interface/ievolucao-fono';
export * from './lib/interface/iavaliacao-nutricional';
export * from './lib/interface/ievolucao-fisioterapia';
export * from './lib/interface/imodule';
export * from './lib/interface/imodule-info';
export * from './lib/interface/iroute';
export * from './lib/interface/icadastro-lista-dal';
export * from './lib/interface/iprocess';
export * from './lib/interface/iprofissional';
export * from './lib/interface/irotina';
export * from './lib/interface/idata-comemorativa';
export * from './lib/interface/iapp-state';
export * from './lib/interface/iapp-addhere-state';
export * from './lib/interface/ischool-state';
export * from './lib/interface/irouter-state';
export * from './lib/interface/itenant-state';
export * from './lib/interface/iprocess-state';
export * from './lib/interface/igeneric-state';
export * from './lib/interface/itenant';
export * from './lib/interface/icad-param';
export * from './lib/interface/iperson-state';
export * from './lib/interface/iperson';
export * from './lib/interface/iclassroom';
export * from './lib/interface/iprofessional';
export * from './lib/interface/ischool';
export * from './lib/interface/ifavorite';
export * from './lib/interface/igeneric';
export * from './lib/interface/isnapiv';
export * from './lib/interface/isnapiv-state';
export * from './lib/interface/idocumento';
export * from './lib/interface/icheck-user';
export * from './lib/interface/inewapi-user-role';
export * from './lib/interface/inewapi-login';
export * from './lib/interface/ilogin';
export * from './lib/interface/ilogin-state';
export * from './lib/interface/ichart';
export * from './lib/interface/iaudio';
export * from './lib/interface/id3data';
export * from './lib/interface/icolumn';
export * from './lib/interface/itarefa-componente';
export * from './lib/interface/iurl';
export * from './lib/interface/iinternacoes';
export * from './lib/interface/ismart-search';
export * from './lib/interface/iqueue';
export * from './lib/interface/iqueue-state';
export * from './lib/interface/ilog-state';
export * from './lib/interface/icost-center-state';
export * from './lib/interface/iutils-email-state';
export * from './lib/interface/ilog';
export * from './lib/interface/ivideo';
export * from './lib/interface/iemail-message';
export * from './lib/interface/iaction-emitter';

// API interfaces
export * from './lib/interface/api/iemail';
export * from './lib/interface/api/igenerate-token';
export * from './lib/interface/api/ivalidate-token-result';
export * from './lib/interface/api/ivalidate-token';
export * from './lib/interface/api/ifile-upload-request';
export * from './lib/interface/api/ifile-upload-response';
export * from './lib/interface/api/ijwt-auth-request';
export * from './lib/interface/api/iattachment-headers-response';
export * from './lib/interface/api/iattachment-headers-request';
export * from './lib/interface/api/ifile-delete-request';
export * from './lib/interface/api/ifile-delete-response';
export * from './lib/interface/api/ifile-edit-request';
export * from './lib/interface/api/ischool-user';
export * from './lib/interface/api/iget-patients-with-medications-request';
export * from './lib/interface/api/iget-redis-request';
export * from './lib/interface/api/iget-ivcf-request';
export * from './lib/interface/api/iget-authorized-patients-request';
export * from './lib/interface/api/ipayload';
export * from './lib/interface/api/iget-medication-count-for-patients-request';
export * from './lib/interface/api/isend-email-response';
export * from './lib/interface/api/ipost-check-medication-stock-request';
export * from './lib/interface/api/ipost-check-medication-stock-response';
export * from './lib/interface/api/idelete-redis-invalidate-cache';
export * from './lib/interface/api/ipost-medication-checkin-request';
export * from './lib/interface/api/ipost-drop-medication-stock-request';
export * from './lib/interface/api/iget-patient-code-request'
// API Fhir
export * from './lib/interface/api/iget-fhir-careplan-fields-request';
export * from './lib/interface/api/iget-fhir-patient-data-request';
export * from './lib/interface/api/iget-fhir-patient-icons-request';
export * from './lib/interface/api/iget-fhir-activity-icons-request';
export * from './lib/interface/api/iget-fhir-activities-request';

// API 2023
export * from './lib/interface/api2023/i-api2023-reqres';

// ADDHERE
export * from './lib/interface/addhere/ievolution';
export * from './lib/interface/addhere/ievolution-state';
export * from './lib/interface/addhere/ieducator';
export * from './lib/interface/addhere/ieducator-state';
export * from './lib/interface/addhere/iresponsible';
export * from './lib/interface/addhere/irelationship';
export * from './lib/interface/addhere/iperson-relationship';
export * from './lib/interface/addhere/iresponsible-state';
export * from './lib/interface/addhere/iprofessional-state';
export * from './lib/interface/addhere/iperson-educator';
export * from './lib/interface/addhere/iperson-professional';
export * from './lib/interface/addhere/iperson-responsible';
export * from './lib/interface/addhere/iperson-responsible-state';
export * from './lib/interface/addhere/iperson-professional-state';
export * from './lib/interface/addhere/iperson-educator-state';
export * from './lib/interface/addhere/ischool-user-state';
export * from './lib/interface/addhere/irpt-screening-tdah-tod';

export * from './lib/interface/addhere/ipost';
export * from './lib/interface/addhere/ipost-state';
export * from './lib/interface/addhere/icomment';
export * from './lib/interface/addhere/icomment-state';
export * from './lib/interface/addhere/iview';
export * from './lib/interface/addhere/iview-state';
export * from './lib/interface/addhere/ipostview';
export * from './lib/interface/addhere/ipostcomment';
export * from './lib/interface/addhere/ipost-comment-state';
export * from './lib/interface/addhere/ipost-view-state';
export * from './lib/interface/addhere/iget-by-school-request';
export * from './lib/interface/addhere/iget-person-authorized-request';

// MedLogic
export * from './lib/interface/medlogic/imedication';
export * from './lib/interface/medlogic/iestoque-materiais';
export * from './lib/interface/medlogic/ihistorico-compra-estoque';
export * from './lib/interface/medlogic/imedication-checkin';
export * from './lib/interface/medlogic/iintervencoes-medicamentos-horarios';
export * from './lib/interface/medlogic/iintervention-medication';
export * from './lib/interface/medlogic/imedlogic-evolution';
export * from './lib/interface/medlogic/imedlogic-professional';
export * from './lib/interface/medlogic/istock-change';
export * from './lib/interface/medlogic/iivcf';
export * from './lib/interface/medlogic/idisability';
export * from './lib/interface/medlogic/ivulnerability';
export * from './lib/interface/medlogic/iprescription-medication';
export * from './lib/interface/medlogic/imedication-grid'
export * from './lib/interface/medlogic/ihorarios'
export * from './lib/interface/input-mask-type';
export * from './lib/interface/medlogic/imedication-list';
export * from './lib/interface/medlogic/ibusiness-unit';
export * from './lib/interface/medlogic/icost-center';
export * from './lib/interface/medlogic/ipresentation';
export * from './lib/interface/medlogic/isaving-status';
export * from './lib/interface/medlogic/iautorizacao-cuidado';
export * from './lib/interface/medlogic/ifamily';
export * from './lib/interface/medlogic/iemployee';
export * from './lib/interface/medlogic/inovo-estoque-material';
export * from './lib/interface/medlogic/iposology';
export * from './lib/interface/medlogic/itherapeutic-safe';
export * from './lib/interface/medlogic/idosage-unity';
export * from './lib/interface/medlogic/itipo-material';
export * from './lib/interface/medlogic/iintervention-medication-history';

// UI
export * from './lib/interface/ui/ismart-list';
export * from './lib/interface/ui/imenu-item';
export * from './lib/interface/ui/isplash';
export * from './lib/interface/ui/ilettering';
export * from './lib/interface/ui/icontact';

// Services
export * from './lib/service/log.service';
export * from './lib/service/global.service';
export * from './lib/service/unsubscribe-ondestroy.adapter';
export * from './lib/service/lib.service';
export * from './lib/service/error';
export * from './lib/service/tap-console';
export * from './lib/service/msg-ptBR.service';
export * from './lib/service/config-json.service';
export * from './lib/service/init-config';
export * from './lib/service/api-routes';

// Enum
export * from './lib/enum/en-color.enum';
export * from './lib/enum/en-content-type.enum';
export * from './lib/enum/en-customer-action.enum';
export * from './lib/enum/en-request-type.enum';
export * from './lib/enum/en-serial-msg.enum';
export * from './lib/enum/en-theme.enum';
export * from './lib/enum/en-typed-value.enum';
export * from './lib/enum/en-user-role.enum';
export * from './lib/enum/en-validation-state.enum';
export * from './lib/enum/en-view-mode.enum';
export * from './lib/enum/enum-ctr-type.enum';
export * from './lib/enum/enum-tipo-lista.enum';
export * from './lib/enum/en-components-view';
export * from './lib/enum/en-modulo.enum';
export * from './lib/enum/en-agrupamento-processos';
export * from './lib/enum/en-login-state.enum';
export * from './lib/enum/en-ws-track-status.enum';
export * from './lib/enum/en-module-mode.enum';
export * from './lib/enum/en-expiration-type';
export * from './lib/enum/en-material-icon.enum';
export * from './lib/enum/en-rpt-type.enum';
export * from './lib/enum/en-invite-status.enum';
export * from './lib/enum/en-type-person.enum';
export * from './lib/enum/en-sort-by.enum';
export * from './lib/enum/en-paper-size.enum';
export * from './lib/enum/en-paper-orientation.enum';
export * from './lib/enum/en-ordem-processo.enum';
export * from './lib/enum/en-video-type.enum';
export * from './lib/enum/en-email-message-status.enum';
export * from './lib/enum/en-prescription-view-mode.enum';
export * from './lib/enum/en-shift.enum';
export * from './lib/enum/en-action-type.enum';
export * from './lib/enum/en-crud.enum';
// ENUM Medlogic
export * from './lib/enum/medlogic/en-stock-status.enum';
export * from './lib/enum/medlogic/en-stock-status.enum';
export * from './lib/enum/medlogic/en-posology.enum';
export * from './lib/enum/medlogic/en-stock-change-mode.enum';
export * from './lib/enum/medlogic/en-stock-change-mode.enum';
export * from './lib/enum/medlogic/en-stock-change.enum';
export * from './lib/enum/medlogic/en-stock-change.enum';
export * from './lib/enum/medlogic/en-ivcf-disability.enum';



// json
// export * as config from './assets/config.json';

// Map
export * from './lib/service/map/map-intervention-medication';
export * from './lib/service/map/map-posologia';
export * from './lib/service/map/map-apresentacao';
export * from './lib/service/map/map-prescription-medication';
export * from './lib/service/map/map-therapeutic-safe';
export * from './lib/service/map/map-medication-checkin';
export * from './lib/service/map/map-estoque-material';
export * from './lib/service/map/map-historico-compra';
export * from './lib/service/map/map-dosage-unity';
export * from './lib/service/map/map-apresentacao';
export * from './lib/service/map/map-tipo-material';

// FHIR
// mode
export * from './lib/enum/fhir/en-activity-type.enum';
export * from './lib/enum/fhir/en-activity-mode.enum';
export * from './lib/enum/fhir/en-activity-status.enum';
export * from './lib/enum/fhir/en-field-type.enum';
export * from './lib/enum/fhir/en-activity-detail-no.enum';
// interfaces
export * from './lib/interface/fhir/ipractitioner';
export * from './lib/interface/fhir/iacceptance-codeable-concept';
export * from './lib/interface/fhir/iactivity';
export * from './lib/interface/fhir/iactivity-contributor';
export * from './lib/interface/fhir/iactivity-detail';
export * from './lib/interface/fhir/iactivity-detail-kind';
export * from './lib/interface/fhir/iactivity-status';
export * from './lib/interface/fhir/iactivity-type-codeable-concept';
export * from './lib/interface/fhir/iaddress';
export * from './lib/interface/fhir/iaspect-codeable-concept';
export * from './lib/interface/fhir/icare-plan';
export * from './lib/interface/fhir/icareplan-activity';
export * from './lib/interface/fhir/icareplan-category';
export * from './lib/interface/fhir/icareplan-intent';
export * from './lib/interface/fhir/icoding';
export * from './lib/interface/fhir/icontact-point';
export * from './lib/interface/fhir/icontributor-on-activity';
export * from './lib/interface/fhir/iday-of-week';
export * from './lib/interface/fhir/idecubitus-position-codeable-concept';
export * from './lib/interface/fhir/idiuresis-color-codeable-concept';
export * from './lib/interface/fhir/idiuresis-quantity-codeable-concept';
export * from './lib/interface/fhir/ievacuation-quantity-codeable-concept';
export * from './lib/interface/fhir/ievent-time';
export * from './lib/interface/fhir/ihuman-name';
export * from './lib/interface/fhir/iidentifier';
export * from './lib/interface/fhir/ioutcome-codeable-concept';
export * from './lib/interface/fhir/ifhir-patient';
export * from './lib/interface/fhir/iproduct-codeable-activity-icons';
export * from './lib/interface/fhir/iproduct-codeable-concept';
export * from './lib/interface/fhir/iproduct-codeable-patient-icons';
export * from './lib/interface/fhir/iproduct-codeable-activity-icons';
export * from './lib/interface/fhir/ipatient-on-careplan';
export * from './lib/interface/fhir/ipractitioner';
export * from './lib/interface/fhir/iprogress';
export * from './lib/interface/fhir/iqualification';
export * from './lib/interface/fhir/ireference';
export * from './lib/interface/fhir/ischeduled';
export * from './lib/interface/fhir/ifrequency';
export * from './lib/interface/fhir/ischeduled-period';
export * from './lib/interface/fhir/ischeduled-timing';
export * from './lib/interface/fhir/ischeduled-timing-repeat';
export * from './lib/interface/fhir/ishift';
export * from './lib/interface/fhir/ifield';
export * from './lib/interface/fhir/ipost-fhir-activity-detail';
